import { AssetType } from "../types/bucketTypes";


export const searchAssets = (assets: AssetType[], searchKeyword: string) => {
    if (!searchKeyword) return assets;
    return assets.filter(asset => filterSearchAssets(asset, searchKeyword));
}

export const filterSearchAssets = (asset: AssetType, searchKeyword: string): boolean => {
    const loweredSearchKeyword = searchKeyword.trim().toLowerCase();

    const esn = asset?.tag?.esn ?? '';
    const serial_number = asset?.bucket?.serial_number ?? '';
    const stock_number = asset?.bucket?.stock_number ?? '';
    const machine_number = asset?.bucket?.machine_number ?? '';
    const make = asset?.bucket?.make ?? '';
    const model = asset?.bucket?.model ?? '';
    const bucketClass = asset?.bucket?.class ?? '';
    const lip_width = asset?.bucket?.lip_width ?? '';
    const manufacturer = asset?.bucket?.manufacturer ?? '';
    const capacity = asset?.bucket?.capacity ?? '';

    return (
        esn.trim().toLowerCase().includes(loweredSearchKeyword) ||
        serial_number.trim().toLowerCase().includes(loweredSearchKeyword) ||
        stock_number.trim().toLowerCase().includes(loweredSearchKeyword) ||
        machine_number.trim().toLowerCase().includes(loweredSearchKeyword) ||
        make.trim().toLowerCase().includes(loweredSearchKeyword) ||
        model.trim().toLowerCase().includes(loweredSearchKeyword) ||
        bucketClass.trim().toLowerCase().includes(loweredSearchKeyword) ||
        lip_width?.toString().trim().toLowerCase().includes(loweredSearchKeyword) ||
        manufacturer.trim().toLowerCase().includes(loweredSearchKeyword) ||
        capacity?.trim().toLowerCase().includes(loweredSearchKeyword)
    )
}